

























































































import Vue from 'vue'
import Component from 'vue-class-component'
import Icon from '@/components/Icon.vue'
import { ISelectItem } from '@/interfaces'
import ScrollView from './ScrollView.vue'
import LoaderWrapper from '@/components/layout/LoaderWrapper.vue'
import { Debounce } from 'vue-debounce-decorator'
// @ts-ignore
import ClickOutside from 'vue-click-outside'

@Component({
  components: {
    LoaderWrapper,
    Icon,
    ScrollView
  },
  directives: {
    ClickOutside
  },
  props: {
    preValidate: { type: Boolean, default: false },
    error: Boolean,
    required: {
      type: [Boolean, String],
      default: false
    },
    placeholder: String,
    clearable: {
      type: Boolean || String,
      default: false
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    items: {
      type: Array,
      required: true
    },
    appendToBody: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    selected: {
      type: [String, Number, Boolean]
    },
    viewMode: {
      type: Boolean,
      default: false
    },
    forceDirection: {
      type: String,
      default: ''
    }
  }
})
export default class Select extends Vue {
  inputValue: string = ''
  direction: string = 'up'

  lastSelected: ISelectItem | null = null
  selectedIndex: number = 0
  isError: boolean = false
  opened: boolean = false

  get displayItems () {
    if (!this.$props.items || !this.$props.items.length) {
      return []
    }
    return this.$props.items.filter((item: ISelectItem) => (
        (typeof item.content === 'number' ? item.content : item.content ? item.content : '').toString().toLowerCase().indexOf(this.inputValue.toLowerCase()) !== -1
    ))
  }

  get isSelected () {
    const selected = this.$props.items.find((item: ISelectItem) => item.value === this.$props.selected)
    return !!selected
  }

  get selectedItemContent () {
    const selected = this.$props.items.find((item: ISelectItem) => item.value === this.$props.selected)
    if (selected) {
      return selected.content
    }
    if (this.$props.placeholder) {
      return this.$props.placeholder
    }
    return ''
  }

  mounted () {
    this.calculateDirection()

    if (this.$props.required) {
      this.$watch('selected', () => {
        this.validate()
      })
      this.$watch('preValidate', () => {
        this.validate()
      })
    }
    if (this.$props.preValidate) {
      this.validate()
    }
  }

  validate () {
    this.isError = this.$props.required ? !this.isSelected : false
  }

  checkNumber (e: any) {
    /** do not use event if manager says so !!!! kills number search */

    // if (/\d/gm.test(e.key)) {
    //   e.preventDefault()
    // }
  }

  selectItem (item: any) {
    if (item.disabled) {
      return
    }
    this.$emit('select', item)
    this.lastSelected = item
    setTimeout(() => this.closeList(), 100)
    // this.closeList()
    // setTimeout(() => this.validate(), 100)
  }

  activate () {
    if (this.$refs.inputField) {
      (this.$refs.inputField as any).focus()
    }
  }

  selectSelectedIndexItem () {
    const item = this.displayItems[this.selectedIndex]
    if (item) {
      this.selectItem(item)
    }
    return false
  }

  changeSelectedIndex (direction: string | null, index: number | null = null) {
    if (direction) {
      const alignScroll = () => {
        const scrollbar: any = this.$refs.scrollbar
        const rect = scrollbar.getBoundingClientRect()
        const listPaddings = 16
        const itemHeight = 38
        const height = rect.height - listPaddings
        const currentPositionTop = this.selectedIndex * itemHeight

        if (currentPositionTop - scrollbar.scrollTop > height - itemHeight && direction === 'down') {
          scrollbar.scrollTop = currentPositionTop - height + itemHeight
        } else if (currentPositionTop < scrollbar.scrollTop && direction === 'up') {
          scrollbar.scrollTop = currentPositionTop - itemHeight
        }
      }
      if (direction === 'up' && this.selectedIndex > 0) {
        this.selectedIndex--
        alignScroll()
      } else if (this.selectedIndex < this.displayItems.length - 1) {
        this.selectedIndex++
        alignScroll()
      }
      return
    }
    if (index) {
      this.selectedIndex = index
    }
  }

  handleInput () {
    this.selectedIndex = 0
    this.lastSelected = this.displayItems.length === 1
        ? this.displayItems[0]
        : null
  }

  // positions dropdown fixed
  positionElementFixed () {
    this.calculateDirection()
    // @ts-ignore
    const el = this.$refs.inputField.getBoundingClientRect()
    // @ts-ignore
    const wrapper = this.$refs.scrollbarWrapper.$el
    wrapper.style.position = 'fixed'
    wrapper.style.top = this.direction === 'up'
      ? `${el.top + el.height - 4}px`
      : `${el.top + el.height + 4}px`
    wrapper.style.left = `${el.left}px`
    wrapper.style.width = `${el.width}px`
  }

  openList () {
    if (this.$props.appendToBody) {
      this.positionElementFixed()
      document.addEventListener('scroll', this.positionElementFixed)
    }

    if (this.$props.disabled) {
      return
    }

    this.calculateDirection()
    this.$nextTick(() => {
      this.$emit('toggle', true)
      this.inputValue = ''
      this.opened = true

      if (!this.$props.selected) {
        return
      }

      const idx: number = this.$props.items.findIndex((x: any) => x.value === this.$props.selected)
      this.selectedIndex = idx >= 0 ? idx : 0
      const scrollbar: any = this.$refs.scrollbar
      if (scrollbar && this.opened) {
        return
      }
      const itemHeight = 38
      scrollbar.scrollTop = this.selectedIndex * itemHeight
    })
  }

  @Debounce(300)
  closeListWithDelay () {
    setTimeout(() => {
      this.closeList()
    }, 200)
  }

  closeList () {
    if (!this.opened) {
      return
    }
    if (this.$props.appendToBody) {
      document.removeEventListener('scroll', this.positionElementFixed)
    }
    this.opened = false
    this.validate()
    this.$emit('toggle', false)
  }

  calculateDirection () {
    if (this.$props.forceDirection) {
      if (this.direction !== this.$props.forceDirection) {
        this.direction = this.$props.forceDirection
      }
      return
    }
    const blockHeight = 40
    const maxBarHeight = 210
    const boxHeight = Math.min(maxBarHeight + blockHeight, blockHeight + this.$props.items.length * 30)
    const rect = (this.$refs.myElement as any).getBoundingClientRect()
    this.direction = rect.y + boxHeight > window.innerHeight ? 'up' : 'down'
  }
}
